import { call, put, takeLatest } from "redux-saga/effects";
import {
  createPaperStart,
  createPaperSuccess,
  createPaperFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { postPaper } from "../../../services/paper";
import { successNotifier } from "../../../utils/helpers";

export function* createPaper({ payload }) {
  const { data, callback } = payload;

  const response = yield call(postPaper, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(createPaperSuccess());
    successNotifier("Subject created successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(createPaperFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onCreatePaper() {
  yield takeLatest(createPaperStart.type, createPaper);
}
